import React from "react";
import { useParams } from "react-router-dom";
import Register from "../components/Register";
import { MODULE_BY_KEY } from "../modules";

export default function ModulePage() {
  const { key } = useParams();
  const module = MODULE_BY_KEY[key];
  if (!module) return <div><h1>Not found</h1><p className="sub">Unknown module: {key}</p></div>;
  return <Register key={module.key} module={module} />;
}
